// extracted by mini-css-extract-plugin
export default {"coverPhoto":"CoverPhoto_coverPhoto__nekh0"};